import React from "react";
import { AIAgentFeature } from "../../../config/marketing/aiAgent";

interface Props {
    feature: AIAgentFeature;
}

export default function AIAgentFeatureRow({ feature }: Props) {
    const Icon = feature.icon;

    return (
        <div className="flex items-center gap-3 rounded-xl bg-white px-4 py-3 shadow-md">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
                <Icon className="h-4 w-4 text-primary" />
            </div>

            <span className="md:text-xl font-medium text-text-primary">{feature.title}</span>
        </div>
    );
}
